<app-navigation></app-navigation>
<ion-img src="../../../assets/img/directions.jpg" class="imageContrast"></ion-img>
<ion-content class="ion-padding">

</ion-content>
